import { render, staticRenderFns } from "./FiveWrap.vue?vue&type=template&id=3ef1e047&scoped=true"
import script from "./FiveWrap.vue?vue&type=script&lang=js"
export * from "./FiveWrap.vue?vue&type=script&lang=js"
import style0 from "./FiveWrap.vue?vue&type=style&index=0&id=3ef1e047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1e047",
  null
  
)

export default component.exports